module.exports = __webpack_public_path__ + "static/media/printing-services-img5.ea794f90.jpg";